/* =============================================================
   PawShift — Quiz Funnel (Settle Assessment) · 7-Step v2
   Vanilla JS state machine. No framework, no bundler, no fbq.
   Implements change-spec 2026-07-15 (C1–C13).
   - one screen at a time; buttons advance (not scroll)
   - G4 pronoun engine: he/she/they with grammar-safe fallbacks
   - deterministic, documented Settle-Match rubric (C8 mapping)
   - C2 low-match page ASSEMBLED from real answers (never contradicts)
   - Step 6B gated to meds-flagged users
   - final CTA scent-matches to the PDP via URL params
   - analytics -> window.dataLayer + ps:quiz custom event ONLY
   ============================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-ps-quiz]');
  if (!root) return;

  var PDP_URL   = root.getAttribute('data-pdp-url') || '/products/daily-calm-protocol';
  var HAS_SPLASH = root.getAttribute('data-splash') === 'true';
  var STORE_KEY = 'ps_quiz_v2';

  /* ---- State ---- */
  var state = {
    name: '', gender: '', breed: '', weight: '', timeHome: '',
    history: [], phase: '', trajectory: '',
    symptoms: [], tried: [], sedation: '', spend: ''
  };
  try {
    var saved = sessionStorage.getItem(STORE_KEY);
    if (saved) state = Object.assign(state, JSON.parse(saved));
  } catch (e) {}
  function persist() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---- Analytics (non-Meta) ---- */
  function track(event, data) {
    var payload = Object.assign({ event: 'ps_quiz_' + event }, data || {});
    (window.dataLayer = window.dataLayer || []).push(payload);
    document.dispatchEvent(new CustomEvent('ps:quiz', { detail: payload }));
  }

  /* =============================================================
     G4 · Pronoun engine — default they/them/their, no broken grammar
     ============================================================= */
  var GRAMMAR = {
    boy:  { they:'he',   theyCap:'He',   theyre:'he’s',  theyve:'he’s',  dont:'doesn’t',  him:'him',  his:'his',   hisCap:'His',   wasnt:'wasn’t',  himself:'himself' },
    girl: { they:'she',  theyCap:'She',  theyre:'she’s', theyve:'she’s', dont:'doesn’t',  him:'her',  his:'her',   hisCap:'Her',   wasnt:'wasn’t',  himself:'herself' },
    they: { they:'they', theyCap:'They', theyre:'they’re', theyve:'they’ve', dont:'don’t', him:'them', his:'their', hisCap:'Their', wasnt:'weren’t', himself:'themselves' }
  };
  function g() { return GRAMMAR[state.gender] || GRAMMAR.they; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function titleCase(s) { return s.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }); }
  function chewWord(d) { return d === 1 ? 'chew' : 'chews'; }
  function dogName() { var n = state.name.trim(); return n ? titleCase(n) : 'your dog'; }
  function dogPos() {
    var n = state.name.trim();
    if (!n) return 'your dog’s';
    var t = titleCase(n);
    return /s$/i.test(t) ? t + '’' : t + '’s';
  }
  function applyText(scope) {
    var s = scope || root, gg = g();
    function fill(cls, val) { s.querySelectorAll('.' + cls).forEach(function (el) { el.textContent = val; }); }
    fill('js-name', dogName());
    fill('js-name-pos', dogPos());
    fill('js-he', gg.they);      fill('js-he-cap', gg.theyCap);
    fill('js-him', gg.him);
    fill('js-his', gg.his);      fill('js-his-cap', gg.hisCap);
    fill('js-theyre', gg.theyre); fill('js-theyre-cap', cap(gg.theyre));
    fill('js-wasnt', gg.wasnt);
    fill('js-himself', gg.himself);
  }

  /* =============================================================
     Lookup maps
     ============================================================= */
  var WEIGHT = {
    'under':  { dose: 1, label: 'under 4.5 kg' },
    '5-18':   { dose: 2, label: '5–18 kg' },
    '18-36':  { dose: 3, label: '18–36 kg' },
    '36plus': { dose: 4, label: '36 kg +' }
  };
  var TIME_HOME = { 'lt3': 'under 3 months', '3-6': 'a few months', '6-12': 'several months', 'over': 'over a year' };
  var HISTORY_TEXT = { 'pound':'a shelter start', 'rehomed':'being rehomed more than once', 'surrendered':'being surrendered', 'neglect':'neglect or an unknown past', 'hardstart':'a hard start you only half-know' };
  var HISTORY_ECHO = { 'pound':'time in the pound or a shelter', 'rehomed':'rehomed more than once', 'surrendered':'surrendered when someone couldn’t cope', 'neglect':'neglect, or a past you don’t fully know', 'hardstart':'a hard start you only half-know' };
  var RESCUE_HISTORY = ['pound', 'rehomed', 'surrendered', 'neglect', 'hardstart'];
  var SYMPTOM_PRESENT = {
    'bark':'barks the moment you leave', 'noise':'bolts or freezes at ordinary noises',
    'yard':'digs at the fence to get out', 'dogs':'gets overwhelmed near other dogs',
    'lead':'hides when the lead comes out', 'pace':'paces like ' /*+name later*/
  };
  var SYMPTOM_ECHO = {
    'bark':'barks the moment you leave', 'noise':'bolts or freezes at noises', 'yard':'digs at the fence',
    'dogs':'gets overwhelmed near other dogs', 'lead':'hides when the lead comes out', 'pace':'paces and can’t switch off'
  };
  var SYMPTOM_TAG = { 'bark':'Separation', 'noise':'Noise-startle', 'yard':'Escape/flight', 'dogs':'Dog-to-dog', 'lead':'Walk-refusal', 'pace':'Can’t-switch-off' };
  var TRIED_TEXT = { 'trainer':'a trainer', 'vet':'the vet’s advice', 'collar':'a calming collar', 'walks':'longer walks', 'enrichment':'enrichment toys', 'treats':'treats when you leave', 'supplement':'another supplement', 'meds':'prescription meds' };
  var SHAPE_STAGE = { 'honeymoon':'Early calm, then a shift', 'never':'Never really settled', 'mixed':'Good days and bad days', 'give-time':'Told to give it time' };
  var SPEND_LABEL = { 'under100':'Under $100', '100-300':'$100–$300', '300-800':'$300–$800', '800-1500':'$800–$1,500', '1500':'$1,500+' };

  /* R3 · customer-language chips — her Step-5 words, never internal angle names */
  var SYMPTOM_CHIP = { 'bark':'Barks when left', 'noise':'Bolts at noises', 'yard':'Digs / tries to get out', 'dogs':'Overwhelmed near other dogs', 'lead':'Hides at the lead', 'pace':'Can’t switch off' };

  /* R5 · matched-owner cards, keyed to top symptom (invented — see manifest) */
  var MATCH_CARDS = {
    'bark':  { ctx:'home 7 months · shelter start · barks when left', quote:'“Home seven months, shelter start, barked the second we left. Six weeks in he settles when I leave instead of losing it.” — Steph M., Ballarat VIC' },
    'yard':  { ctx:'rehomed twice · fence-runner', quote:'“Rehomed twice before us, and a fence-runner from week one. We found her two streets over, twice. Six weeks in she naps through the postie. Still digs a bit before storms.” — Renee K., Ipswich QLD' },
    'dogs':  { ctx:'reactive on walks · shelter start', quote:'“He couldn’t walk past another dog without losing it, so we walked at 5am to avoid everyone. A month and a half in, we do the park at normal hours. Not perfect, but calm enough to learn.” — Dario P., Frankston VIC' },
    'noise': { ctx:'noise-startle · rescue', quote:'“Every truck and door-knock sent him bolting for the bedroom. Six weeks on he lifts his head and stays put. Thunder’s still a bit much.” — Lena F., Geelong VIC' },
    'lead':  { ctx:'shut down at the lead · pound start', quote:'“She used to hide under the table when the lead came out. About five weeks in she meets me at the door for walks now. Still slow on busy days.” — Tom H., Marrickville NSW' },
    'pace':  { ctx:'couldn’t switch off · rescue', quote:'“He paced till midnight, every night. A month in he actually sleeps through. Still a shadow on bin day.” — Aisha R., Adelaide SA' }
  };

  /* H1 · PDP-handoff param codes */
  var WEIGHT_CODE = { 'under':'u45', '5-18':'5-18', '18-36':'18-36', '36plus':'36plus' };
  var PATTERN_CODE = { 'bark':'separation', 'noise':'noise', 'yard':'escape', 'dogs':'dogdog', 'lead':'lead', 'pace':'baseline' };

  /* S2 · bridge "tried_phrase" — from her single Step-6 selection; 0/many/ambiguous -> fallback */
  var TRIED_PHRASE = { 'trainer':'the training', 'vet':'the vet visits', 'collar':'the collar', 'walks':'the longer walks', 'enrichment':'the Kongs', 'treats':'the treats', 'supplement':'the other chews' };
  function triedPhrase() {
    var real = state.tried.filter(function (t) { return t !== 'nothing'; });
    if (real.length === 1 && TRIED_PHRASE[real[0]]) return TRIED_PHRASE[real[0]];
    return 'everything you’ve tried';
  }

  /* Breed-matched review cards (C4). Counts + reviews are invented placeholders
     logged in INVENTED-MANIFEST.md — swap for PDP-mined reviews on mining. */
  var BREED_PROOF = {
    'staffy':  { n:'340+', label:'Staffies', review:'“Ruby’s a pound Staffy. The barking the second we left was doing our heads in. A month in, she settles on her mat when I pick up my keys. Storm nights are still a work in progress, but she’s herself again.” — Jess T., Ipswich QLD' },
    'kelpie':  { n:'210+', label:'Kelpies', review:'“Working-line Kelpie in a suburban yard, Bluey paced the fence for hours a day. He still needs his big runs, but now he can actually switch off afterwards.” — Sam W., Ballarat VIC' },
    'collie':  { n:'180+', label:'Border Collies', review:'“Nessa’s a Border Collie from a farm surrender. She’d bolt at the vacuum and pace till midnight. About five weeks in she started actually lying down of an evening. Still not a fan of the mower.” — Dan H., Armidale NSW' },
    'heeler':  { n:'160+', label:'Blue Heelers', review:'“Koda’s a Blue Heeler off a station. Barked and circled every time we left the room. He’s got a job to do still, but a month in he can settle on his bed instead of guarding the door.” — Bec M., Toowoomba QLD' },
    'jackrussell': { n:'150+', label:'Jack Russells', review:'“Pip’s a Jack Russell from the pound, dug under the fence and barked at every possum. Took about a month; now she digs less and sleeps through most nights. Still opinionated about the postie.” — Lauren K., Geelong VIC' },
    'greyhound':{ n:'120+', label:'Greyhounds', review:'“Banjo raced for three years and didn’t know what a couch was. He’d freeze at every noise on walks. Six weeks in, he walks past the bin truck like it’s nothing.” — Mark & Elise D., Newcastle NSW' },
    'gsd':     { n:'190+', label:'German Shepherds', review:'“Zara’s an ex-guarding German Shepherd. She froze and paced at every noise in the street. Six weeks on she walks past the bins without flinching. Fireworks are still a hard no.” — Peter A., Penrith NSW' },
    'small':   { n:'230+', label:'small fluffies', review:'“Milo’s a Maltese cross from a surrender, paced and panted every single night. Took a good five weeks, honestly. Now he flops at eight o’clock like he’s done it all his life.” — Karen B., Bendigo VIC' },
    'mixed':   { n:'1,200+', label:'rescue mixes', review:'“Our bitsa Daisy dug out of the yard twice in her first month home. She still digs a bit when a storm’s coming, but the fence-running has stopped.” — Tegan R., Logan QLD' },
    'other':   { n:'1,200+', label:'rescue dogs', review:'“Whatever’s in our Ollie, a bit of everything from the pound. He paced and couldn’t switch off at night. A few weeks in he finally sleeps through. Still barks at skateboards.” — Nadia S., Fremantle WA' }
  };

  function symptomPhrase(v) {
    if (v === 'pace') return 'paces like ' + dogName() + ' can’t switch off';
    return SYMPTOM_PRESENT[v];
  }

  /* =============================================================
     Deterministic Settle-Match rubric  (C8 mapping, documented)
     Base 8 + rescue-history 25 + buying-trigger 20
            + symptoms 5×(max5) + tried 3×(max5) + sedation-concern 7
     Buying-trigger (the 3-month-wall signal) now comes from
     Step 3 time (6–12mo / over a year) OR Step 4 shape options
     'never' / 'give-time' OR trajectory same/worse.   cap 5..99
     ============================================================= */
  function hasRescueHistory() { return state.history.some(function (h) { return RESCUE_HISTORY.indexOf(h) > -1; }); }

  /* A "need signal" = any answer that suggests a stuck/struggling dog PawShift
     can help. PawShift helps in most cases, so the bar for high match is low:
     ONE of these is enough. */
  function needSignal() {
    return hasRescueHistory() ||
           state.symptoms.length >= 1 ||
           state.trajectory === 'worse' ||
           ['never', 'give-time'].indexOf(state.phase) > -1 ||
           state.tried.indexOf('meds') > -1;
  }
  /* Low match is a NARROW gate — fires only when the answers show essentially
     no need (no rescue past, zero symptoms, not worsening, not stuck, no meds).
     Everyone else is a high match and flows to the offer. */
  function isLowMatch() { return !needSignal(); }

  /* Buying-trigger (3-month-wall) — nudges the high-band score up a touch. */
  function trigger() {
    return ['never', 'give-time'].indexOf(state.phase) > -1 ||
           ['6-12', 'over'].indexOf(state.timeHome) > -1 ||
           state.trajectory === 'same' || state.trajectory === 'worse';
  }
  /* High-band Settle-Match score: skews high (≈73–97) with mild, deterministic
     variation so it feels computed without being elastic. Fit, never efficacy. */
  function computeScore() {
    var s = 70;
    if (hasRescueHistory()) s += 8;
    if (trigger()) s += 8;
    s += Math.min(state.symptoms.length, 4) * 3;                 // max +12
    var triedReal = state.tried.filter(function (t) { return t !== 'nothing'; });
    s += Math.min(triedReal.length, 5) * 1;                      // max +5
    if (state.tried.indexOf('meds') > -1) s += 4;
    return Math.max(70, Math.min(97, s));
  }
  /* Honest low number shown only on the (rare) low-match page. */
  function lowScore() {
    var s = 40;
    if (state.trajectory === 'comes-goes') s += 4;
    if (state.timeHome === '3-6') s += 3;
    return Math.min(49, s);
  }
  function lowBranch() {
    return (state.timeHome === 'lt3' && state.trajectory === 'better') ? 'A' : 'B';
  }

  /* =============================================================
     Screen navigation
     ============================================================= */
  var screens = {};
  root.querySelectorAll('[data-screen]').forEach(function (el) { screens[el.getAttribute('data-screen')] = el; });
  var progressEl = root.querySelector('[data-progress]');
  var stack = [];
  var current = null;

  var PROG = {
    step1:  { step:'Step 1 of 7', seg:1, s1:33,  s2:0,   s3:0 },
    step2:  { step:'Step 2 of 7', seg:1, s1:66,  s2:0,   s3:0 },
    step3:  { step:'Step 3 of 7', seg:1, s1:100, s2:0,   s3:0 },
    step4:  { step:'Step 4 of 7', seg:2, s1:100, s2:33,  s3:0 },
    step5:  { step:'Step 5 of 7', seg:2, s1:100, s2:66,  s3:0 },
    step6:  { step:'Step 6 of 7', seg:2, s1:100, s2:100, s3:0 },
    step6b: { step:'Step 6 of 7', seg:2, s1:100, s2:100, s3:0 },
    step7:  { step:'Step 7 of 7', seg:3, s1:100, s2:100, s3:100 }
  };
  var STEP_SCREENS = { step1:1, step2:1, step3:1, step4:1, step5:1, step6:1, step6b:1, step7:1 };

  function updateProgress(id) {
    var p = PROG[id];
    if (!p || !progressEl) { if (progressEl) progressEl.hidden = true; return; }
    progressEl.hidden = false;
    progressEl.querySelector('[data-progress-step]').textContent = p.step;
    progressEl.querySelector('[data-seg="1"]').style.width = p.s1 + '%';
    progressEl.querySelector('[data-seg="2"]').style.width = p.s2 + '%';
    progressEl.querySelector('[data-seg="3"]').style.width = p.s3 + '%';
    progressEl.querySelectorAll('[data-segname]').forEach(function (el) {
      el.classList.toggle('on', +el.getAttribute('data-segname') === p.seg);
      if (el.getAttribute('data-segname') === '1') el.textContent = 'About ' + dogName();
    });
  }

  function show(id, isBack) {
    if (!screens[id]) return;
    if (current && !isBack) stack.push(current);
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== id); });
    current = id;
    updateProgress(id);
    window.scrollTo(0, 0);
    applyText();
    var h = screens[id].querySelector('h1, h2, .i-title');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    if (STEP_SCREENS[id]) track('step_view', { step: id });
    if (id === 'interstitial') runInterstitial();
    if (id === 'results') track('profile_view', {});
    if (id === 'lowmatch') track('low_match', { branch: lowBranch() });
  }
  function back() { var prev = stack.pop(); if (prev) show(prev, true); }

  function nextFrom(id) {
    switch (id) {
      case 'splash':  return 'step1';
      case 'step1':   return 'step2';
      case 'step2':   return 'step3';
      case 'step3':   return 'step4';
      case 'step4':   return 'step5';
      case 'step5':   return 'step6';
      case 'step6':   return state.tried.indexOf('meds') > -1 ? 'step6b' : 'step7';
      case 'step6b':  return 'step7';
      case 'step7':   return 'interstitial';
      case 'interstitial': return isLowMatch() ? 'lowmatch' : 'results';
    }
    return null;
  }

  function screenValid(id) {
    var ok = true;
    screens[id].querySelectorAll('[data-required]').forEach(function (grp) {
      var val = state[grp.getAttribute('data-field')];
      if (Array.isArray(val) ? val.length === 0 : !val) ok = false;
    });
    return ok;
  }
  function refreshCta(id) {
    var scr = screens[id]; if (!scr) return;
    var cta = scr.querySelector('[data-next]');
    if (cta && scr.querySelector('[data-required]')) cta.setAttribute('aria-disabled', screenValid(id) ? 'false' : 'true');
  }

  /* =============================================================
     Input wiring
     ============================================================= */
  root.addEventListener('click', function (e) {
    var opt = e.target.closest('.q-option, .q-chip, .q-tile');
    if (opt && root.contains(opt)) {
      var grp = opt.closest('.q-options, .q-chips, .q-tiles');
      if (!grp) return;
      var field = grp.getAttribute('data-field');
      var type = grp.getAttribute('data-type');
      var value = opt.getAttribute('data-value');
      if (type === 'multi') {
        var arr = state[field], i = arr.indexOf(value);
        if (i > -1) { arr.splice(i, 1); opt.classList.remove('is-selected'); }
        else { arr.push(value); opt.classList.add('is-selected'); }
      } else {
        var wasSel = opt.classList.contains('is-selected');
        grp.querySelectorAll('.q-option, .q-chip, .q-tile').forEach(function (o) { o.classList.remove('is-selected'); });
        if (field === 'gender' && wasSel) { state[field] = ''; }  // chips are deselectable (optional)
        else { opt.classList.add('is-selected'); state[field] = value; }
      }
      persist();
      refreshCta(current);
      if (field === 'weight') { updateDoseHint(); renderProof(); }
      if (field === 'gender') applyText();
      return;
    }
    var why = e.target.closest('.q-why');
    if (why && root.contains(why)) {
      var panel = why.nextElementSibling;
      if (panel && panel.classList.contains('q-why-panel')) { panel.hidden = !panel.hidden; if (!panel.hidden) track('why_expand', { step: current }); }
      return;
    }
    var next = e.target.closest('[data-next]');
    if (next && root.contains(next)) {
      e.preventDefault();
      if (next.getAttribute('aria-disabled') === 'true') return;
      if (!screenValid(current)) { refreshCta(current); return; }
      var dest = nextFrom(current);
      if (dest === 'interstitial') track('complete', { score: computeScore() });
      if (dest) show(dest);
      return;
    }
    var b = e.target.closest('[data-back]');
    if (b && root.contains(b)) { e.preventDefault(); back(); return; }
    var skip = e.target.closest('[data-skip]');
    if (skip && root.contains(skip)) { e.preventDefault(); track('skip', {}); window.location.href = buildHandoffUrl(); return; }
  });

  var nameInput = root.querySelector('[data-field="name"]');
  if (nameInput) {
    nameInput.value = state.name;
    nameInput.addEventListener('input', function () { state.name = nameInput.value; persist(); applyText(); refreshCta(current); updateProgress(current); });
  }

  var proofCard = root.querySelector('[data-proof]');
  // Per-breed image URLs, versioned by asset_url (rendered in the section as a
  // JSON blob) so the CDN's 1-year cache is busted when a file changes.
  var BREED_IMGS = {};
  (function () {
    var el = root.querySelector('[data-breed-imgs]');
    if (el) { try { BREED_IMGS = JSON.parse(el.textContent); } catch (e) {} }
  })();
  function renderProof() {
    if (!proofCard) return;
    var p = BREED_PROOF[state.breed];
    // C6: appears only once BOTH breed and weight are answered
    if (!p || !state.weight) { proofCard.hidden = true; return; }
    proofCard.hidden = false;
    proofCard.querySelector('[data-proof-count]').textContent = 'We’ve helped ' + p.n + ' ' + p.label + ' settle';
    proofCard.querySelector('[data-proof-quote]').textContent = p.review;
    // per-breed photo — 'other' has no image of its own, it borrows 'mixed'
    var img = proofCard.querySelector('[data-proof-img]');
    if (img) {
      var slug = (state.breed === 'other') ? 'mixed' : state.breed;
      var fb = BREED_IMGS.fallback || img.getAttribute('src');
      img.onerror = function () { this.onerror = null; this.src = fb; };
      img.src = BREED_IMGS[slug] || fb;
      img.alt = 'A settled ' + p.label.replace(/\+$/, '') + ' at home';
    }
  }

  var doseHint = root.querySelector('[data-dose-hint]');
  function updateDoseHint() {
    if (!doseHint) return;
    var w = WEIGHT[state.weight];
    if (!w) { doseHint.hidden = true; return; }
    doseHint.hidden = false;
    doseHint.textContent = cap(w.label) + ' → ' + w.dose + (w.dose === 1 ? ' chew' : ' chews') + ' a day for ' + dogName();
  }

  /* =============================================================
     Interstitial
     ============================================================= */
  var interstitialTimer = null;
  function runInterstitial() {
    var steps = screens.interstitial.querySelectorAll('.i-step');
    steps.forEach(function (s) { s.classList.remove('on'); });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var per = reduce ? 60 : 520;
    steps.forEach(function (s, i) { setTimeout(function () { s.classList.add('on'); }, per * (i + 1)); });
    var e1 = screens.interstitial.querySelector('[data-echo-history]'); if (e1) e1.textContent = historyEcho();
    var e2 = screens.interstitial.querySelector('[data-echo-pattern]'); if (e2) e2.textContent = patternEcho();
    clearTimeout(interstitialTimer);
    interstitialTimer = setTimeout(function () { renderResults(); show(nextFrom('interstitial')); }, reduce ? 500 : (per * steps.length + 700));
  }
  function historyEcho() {
    var h = state.history.filter(function (x) { return RESCUE_HISTORY.indexOf(x) > -1; });
    return (h.length ? HISTORY_ECHO[h[0]] : 'their early start');
  }
  function patternEcho() {
    var s = state.symptoms.slice(0, 1).map(function (x) { return SYMPTOM_ECHO[x]; }).filter(Boolean);
    return s.length ? s.join(', ') : 'unsettled at home';
  }

  /* =============================================================
     Results assembly
     ============================================================= */
  function pickList(arr, map, max, joinWord) {
    var out = arr.map(function (v) { return map[v]; }).filter(Boolean).slice(0, max || 3);
    if (out.length <= 1) return out.join('');
    return out.slice(0, -1).join(', ') + ' ' + (joinWord || 'and') + ' ' + out[out.length - 1];
  }
  /* H1 · carry assessment context to the PDP via URL params + localStorage fallback */
  function handoffData() {
    var w = WEIGHT[state.weight] || {};
    return {
      ps_name: dogName(),
      ps_score: computeScore(),
      ps_dose: w.dose || '',
      ps_weight: WEIGHT_CODE[state.weight] || state.weight || '',
      ps_pattern: state.symptoms.slice(0, 3).map(function (x) { return PATTERN_CODE[x]; }).filter(Boolean).join(','),
      ps_spend: state.spend || '',
      ps_gender: state.gender || ''
    };
  }
  function buildHandoffUrl() {
    var d = handoffData(), params = [];
    Object.keys(d).forEach(function (k) { if (d[k] !== '' && d[k] != null) params.push(k + '=' + encodeURIComponent(d[k])); });
    params.push('src=quiz');
    try { localStorage.setItem('ps_quiz_handoff', JSON.stringify(d)); } catch (e) {}
    return PDP_URL + (PDP_URL.indexOf('?') > -1 ? '&' : '?') + params.join('&');
  }

  function renderResults() {
    var low = isLowMatch();
    var scr = low ? screens.lowmatch : screens.results;
    applyText(scr);

    if (low) { renderLowMatch(scr, lowScore()); return; }

    var score = computeScore();
    var gg = g();
    setText(scr, '[data-score-num]', score);
    setGauge(scr, score);
    var reading = Math.round(score * 0.8);
    setText(scr, '[data-reading]', (reading >= 65 ? 'High' : reading >= 40 ? 'Moderate' : 'Low') + ' (' + reading + '/100)');
    setText(scr, '[data-find-stage]', SHAPE_STAGE[state.phase] || '—');
    var tags = state.symptoms.slice(0, 2).map(function (x) { return SYMPTOM_CHIP[x]; }).filter(Boolean);
    setText(scr, '[data-find-pattern]', tags.join(' + ') || '—');
    var triedReal = state.tried.filter(function (t) { return t !== 'nothing'; });
    setText(scr, '[data-find-tried]', triedReal.length + ' thing' + (triedReal.length === 1 ? '' : 's') + ' · window 4–6 wks');

    renderTags(scr, tags);
    setText(scr, '[data-reflection]', buildReflection());

    var w = WEIGHT[state.weight] || { dose: 2, label: '5–18 kg' };

    // S2 · bridge fills (reframe → discovery → curve → plan)
    setText(scr, '[data-tried-phrase]', triedPhrase());
    setText(scr, '[data-bridge-dose]', w.dose + ' ' + chewWord(w.dose));
    setText(scr, '[data-curve-name]', dogName() + ' now');

    // H1 · handoff to the PDP (no transaction on this page)
    var hurl = buildHandoffUrl();
    scr.querySelectorAll('[data-cta-handoff]').forEach(function (el) {
      el.setAttribute('href', hurl);
      el.addEventListener('click', function () { buildHandoffUrl(); track('cta_handoff', { score: score }); }, { once: true });
    });
  }

  /* C2 · Low-match page assembled from real answers (never contradicts) */
  function renderLowMatch(scr, score) {
    setText(scr, '[data-lm-score]', score);
    setGauge(scr, score);
    // 1 · Echo block — 2 true things, priority history > symptom > stage
    var echo = [];
    var hist = state.history.filter(function (x) { return RESCUE_HISTORY.indexOf(x) > -1; })[0];
    if (hist) echo.push(HISTORY_ECHO[hist]);
    if (state.symptoms[0]) echo.push(SYMPTOM_ECHO[state.symptoms[0]]);
    if (echo.length < 2 && state.timeHome) echo.push('home ' + TIME_HOME[state.timeHome]);
    if (echo.length < 2 && state.phase) echo.push((SHAPE_STAGE[state.phase] || '').toLowerCase());
    setText(scr, '[data-lm-echo]', echo.length ? 'You told us: ' + echo.slice(0, 2).join(', and ') + '.' : '');
    // 2 · Reason block — keyed to why the rubric scored low
    setText(scr, '[data-lm-reason]', lowReason());
  }
  function lowReason() {
    var name = dogName(), gg = g();
    switch (lowBranch()) {
      case 'A':
        return name + '’s had a rough start — and ' + gg.theyve + ' only been home a short while, and already improving. That’s the settling curve doing its job. Right now, time and routine are genuinely on your side — a daily supplement isn’t what this stage needs.';
      case 'B':
        return 'Honestly? ' + name + '’s answers don’t show the pattern PawShift was built for. That’s good news — it means what you’re seeing is likely normal adjustment, not a stress system that’s stuck.';
      default:
        return name + ' looks like ' + gg.theyre + ' settling the way rescues are supposed to — slowly, with wobbles. We’d rather tell you that than sell you something ' + gg.they + ' ' + gg.dont + ' need.';
    }
  }

  function buildReflection() {
    var name = dogName(), gg = g();
    var startSel = state.history.filter(function (x) { return RESCUE_HISTORY.indexOf(x) > -1; })[0];
    var startTxt = startSel ? HISTORY_TEXT[startSel] : 'a tough start';
    var sym = state.symptoms.map(symptomPhrase).filter(Boolean).slice(0, 2);
    var tried = pickList(state.tried.filter(function (t) { return t !== 'nothing'; }), TRIED_TEXT, 3, 'and');
    var s = name + ' came home ' + (TIME_HOME[state.timeHome] || 'a while') + ' ago from ' + startTxt + '.';
    if (sym.length) s += ' Now ' + name + ' ' + sym.join(', and ') + '.';
    if (tried) s += ' You’ve tried ' + tried + ' — and ' + gg.they + ' still can’t settle.';
    return s;
  }
  function projectionDate() {
    var d = new Date(); d.setDate(d.getDate() + 42);
    var m = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return d.getDate() + ' ' + m[d.getMonth()];
  }
  function renderTags(scr, symptomTags) {
    var box = scr.querySelector('[data-tags]'); if (!box) return;
    box.innerHTML = '';
    var chips = [];
    if (state.timeHome) chips.push('Home ' + (TIME_HOME[state.timeHome] || ''));
    var start = state.history.filter(function (x) { return RESCUE_HISTORY.indexOf(x) > -1; })[0];
    if (start) chips.push(HISTORY_ECHO[start]);
    symptomTags.forEach(function (t) { chips.push(t); });
    var triedReal = state.tried.filter(function (t) { return t !== 'nothing'; });
    if (triedReal.length) chips.push('Tried ' + triedReal.length + ' thing' + (triedReal.length === 1 ? '' : 's'));
    chips.slice(0, 5).forEach(function (c) { var s = document.createElement('span'); s.className = 'r-tag'; s.textContent = cap(c); box.appendChild(s); });
  }

  function setText(scope, sel, txt) { scope.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
  function setGauge(scope, score) {
    var fill = scope.querySelector('[data-gauge-fill], [data-lm-gauge-fill]');
    var pt = scope.querySelector('[data-gauge-pointer], [data-lm-gauge-pointer]');
    if (fill) requestAnimationFrame(function () { fill.style.width = score + '%'; });
    if (pt) requestAnimationFrame(function () { pt.style.left = score + '%'; });
  }

  /* ---- Boot ---- */
  renderProof();
  updateDoseHint();
  var breedSel = root.querySelector('[data-field="breed"]');
  if (breedSel && state.breed) { var pre = breedSel.querySelector('[data-value="' + state.breed + '"]'); if (pre) pre.classList.add('is-selected'); }
  ['step1','step2','step3','step4','step5','step6','step6b','step7'].forEach(refreshCta);
  show(HAS_SPLASH ? 'splash' : 'step1');
  track('start', {});

  // Warm the per-breed proof images at idle (from the versioned BREED_IMGS map)
  // so the Step-2 card swaps instantly on tap instead of fetching on click.
  (function prefetchBreedImages() {
    var urls = Object.keys(BREED_IMGS).map(function (k) { return BREED_IMGS[k]; });
    if (!urls.length) return;
    var run = function () { urls.forEach(function (u) { new Image().src = u; }); };
    (window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); })(run);
  })();
})();
